import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Location } from '../modal/location';

export const deleteLocationAPI = async (fieldId: string) => {
  const resp = await baseAPI.delete<Location>(`/custom-form/${fieldId}`);
  return resp.data;
};

export const useDeleteLocationMutation = () => {
  return useMutation({
    mutationFn: async ({ fieldId }: { fieldId: string }) => {
      const response = await deleteLocationAPI(fieldId);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.LOCATIONS,
      });
    },
  });
};
